import React from "react";
import { motion } from "framer-motion";
import { CalendarIcon, ClipboardListIcon, RefreshCwIcon, TagIcon, FileTextIcon, GiftIcon, BoxIcon } from "lucide-react";
import { bonos, valorTotalBonos } from "../data/bonos";
const icons: BoxIcon[] = [CalendarIcon, ClipboardListIcon, RefreshCwIcon, TagIcon, FileTextIcon];
export function Bonuses() {
  return <section className="w-full bg-gray-50 px-6 py-20 sm:px-10" data-id="element-17" data-mp="fsbnmskxl71v">
      <div className="mx-auto max-w-6xl text-center" data-id="element-18" data-mp="1tc0jpd2h07t">
        <h2 className="font-heading text-2xl font-bold text-mint-dark sm:text-3xl" data-id="element-19" data-mp="5w0bq3p96j7y">+ 5 bonos exclusivos</h2>
        <p className="mt-2 text-lg text-gray-500" data-id="element-20" data-mp="3o1v5efaefsp5">Sin costo adicional hoy</p>

        <div className="mt-12 grid grid-cols-1 gap-6 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="3o3pp5q9xpern">
          {bonos.map((bono, index) => {
          const Icon = icons[index] ?? GiftIcon;
          return <motion.div key={bono.numero} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-xl bg-white p-7" style={{
            border: `2px solid ${bono.color}`
          }} data-id="element-22" data-mp="1m85m1n1vtsks" data-mpi={index}>
                <span className="flex h-10 w-10 items-center justify-center rounded-full" style={{
              backgroundColor: `${bono.color}1A`,
              color: bono.colorTextDark
            }} data-id="element-23" data-mp="3n79bhpi9lbbv">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-24" data-mp="2uiu1xihwjl7x" />
                </span>
                <h3 className="mt-4 text-base font-bold" style={{
              color: bono.colorTextDark
            }} data-id="element-25" data-mp="38e5t5fwumtk3">
                  Bono {bono.numero}: {bono.titulo}
                </h3>
                <p className="mt-2 text-sm italic text-gray-700" data-id="element-26" data-mp="no6rtpab7iqg">{bono.subtitulo}</p>
                <ul className="mt-4 space-y-1.5" data-id="element-27" data-mp="iqewelaghehi">
                  {bono.bullets.map(bullet => <li key={bullet} className="text-xs text-gray-500" data-id="element-28" data-mp="3chv4tp2jtam4">
                      • {bullet}
                    </li>)}
                </ul>
                <div className="mt-5 flex flex-col items-start gap-1" data-id="element-29" data-mp="3hjua54humhlp">
                  <span className="inline-flex w-fit items-center gap-1.5 rounded-md bg-mint-deep px-3 py-1.5 text-sm font-bold text-success" data-id="element-30" data-mp="3lk4g4h5n580k">
                    <span className="text-gray-400 line-through" data-id="element-31" data-mp="2tsoryiofrd88">{bono.valorOriginal}</span>
                    <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="2xu0c48ojj691" />
                    HOY GRATIS
                  </span>
                  <span className="text-[11px] font-bold uppercase tracking-wide text-coral" data-id="element-33" data-mp="32sv1jth0jt24">Solo hoy, sin costo</span>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="mt-14" data-id="element-34" data-mp="2a4z8cyqnkja3">
          <p className="font-heading text-2xl font-bold text-mint-dark sm:text-3xl" data-id="element-35" data-mp="2a3o5r28y1hkk">
            Valor total de los bonos: {valorTotalBonos}
          </p>
          <p className="mt-2 flex items-center justify-center gap-2 text-lg font-bold text-coral sm:text-xl" data-id="element-36" data-mp="27jrifrjhilx1">
            <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-37" data-mp="22kexjcc6box3" /> Hoy incluidos sin costo
          </p>
        </div>
      </div>
    </section>;
}